import React from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import Button from '@material-ui/core/Button';
import QuizForm from '../Quiz/QuizForm';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {createForm} from 'rc-form';
import {isEmpty} from 'lodash/lang';
import {PrimaryButton, SecondaryButton} from '../common/StyledButtons';
import QuizOptions from './QuizOptions';
import {Grid} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Colors, {withOpacity} from '../common/Colors';

/**
 * Icons
 */
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Check from '@material-ui/icons/Done';
import Shuffle from '@material-ui/icons/Shuffle';
import UpArrow from '@material-ui/icons/ArrowDropUp';
import DownArrow from '@material-ui/icons/ArrowDropDown';
import ExpandAll from '@material-ui/icons/ViewList';
import CollapseAll from '@material-ui/icons/List';

const numQuestions = (questions) => {
    let total = questions.reduce((acc, question) => {
        if (question.hasOwnProperty('numberOfQuestions')){
            let num = parseInt(question.numberOfQuestions);
            if (!isNaN(num)) acc = acc + num;
        }
        else acc = acc + 1;
        return acc;
    }, 0);

    return total;
};

class QuizDetail extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            expanded: []
        };

    }

    componentDidMount(){
        const {quizDataDict} = this.props;
        if (!isEmpty(quizDataDict)){
            if (!isEmpty(quizDataDict.questions)) {
                this.setState({expanded: quizDataDict.questions.map(() => false)});
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (isEmpty(prevProps.quizDataDict)) {
            const {quizDataDict} = this.props;
            if (!isEmpty(quizDataDict)){
                if (!isEmpty(quizDataDict.questions)) {
                    this.setState({expanded: quizDataDict.questions.map(() => false)});
                }
            }
        }
    }

    handleUp(e, quizQuestionIndex){
        const {moveUp} = this.props;
        const {expanded} = this.state;
        e.stopPropagation();
        moveUp(quizQuestionIndex);

        if (quizQuestionIndex > 0 && !expanded[quizQuestionIndex - 1]){
            expanded[quizQuestionIndex -1] = true;
            expanded[quizQuestionIndex] = false;
            this.setState(expanded);
        }

    }

    handleDown(e, quizQuestionIndex){
        const {moveDown} = this.props;
        const {expanded} = this.state;
        e.stopPropagation();
        moveDown(quizQuestionIndex);

        if (quizQuestionIndex < expanded.length - 1 && !expanded[quizQuestionIndex + 1]){
            expanded[quizQuestionIndex +1] = true;
            expanded[quizQuestionIndex] = false;
            this.setState(expanded);
        }
    }

    render() {
        const {
            removeQuestionFromQuizAction, editRandomizedQuizQuestionAction, saveQuiz,
            addRandomizedQuestion, form, quizDataDict, submitting, onChange, getAdvancedOptions
        } = this.props;

        const {expanded} = this.state;

        return (
            <div className="quiz-detail-container">
                <div className="quiz-detail-form">
                    <QuizForm {...{
                        form,
                        onSubmit: saveQuiz,
                        initialValues: quizDataDict,
                        submitting,
                        onChange
                    }} />
                </div>
                <h3 className="section-header">
                    <div className="section-title">Quiz Questions</div>
                </h3>
                <QuizOptions
                    updateAdvancedOptions={getAdvancedOptions}
                    initialData={quizDataDict.options}
                    quizUUID={quizDataDict._id ? quizDataDict._id.$oid : ''}
                    onChange={onChange}
                />
                {!isEmpty(quizDataDict.questions) && quizDataDict.questions.length > 0 ?
                    <p>{numQuestions(quizDataDict.questions)} question(s) added</p> :
                    <p>No questions have been added to the quiz.</p>}
                <div className="quiz-detail-questions">
                    <Box m={1}>
                        <Grid
                            container
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                        >
                            <PrimaryButton onClick={() => {
                                let currExpanded = expanded;
                                currExpanded = currExpanded.map(() => true);
                                this.setState({expanded: currExpanded});}}>
                                <ExpandAll/> Expand All
                            </PrimaryButton>
                            <PrimaryButton onClick={() => {
                                let currExpanded = expanded;
                                currExpanded = currExpanded.map(() => false);
                                this.setState({expanded: currExpanded});}}>
                                <CollapseAll/> Collapse All
                            </PrimaryButton>
                        </Grid>
                    </Box>
                    {!isEmpty(quizDataDict.questions) && expanded !== [] &&
                    quizDataDict.questions.map((question, quizQuestionIndex) => (
                        <ExpansionPanel expanded={expanded[quizQuestionIndex] === true} key={`quiz-question-${quizQuestionIndex}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                let currExpanded = expanded;
                                currExpanded[quizQuestionIndex] = !currExpanded[quizQuestionIndex];
                                this.setState({expanded: currExpanded});}}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon/>}
                                aria-controls={`panel-${quizQuestionIndex}-content`}
                                id={`${question._cls === 'Question' ? 'normal' : 'random'}-panel-header-${quizQuestionIndex}`}
                            >
                                <Typography>
                                    {question._cls === 'Question' ? question.name :
                                        'Random Question Set'}
                                </Typography>
                                { question._cls !== 'Question' &&
                                    <>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <Box fontStyle={"italic"} color={withOpacity('#333333', '88')} clone>
                                            <Typography>{`${question.topic}`} </Typography>
                                        </Box>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <Typography>
                                            {` ${question.numberOfQuestions} Question${question.numberOfQuestions != '1' ? 's' : ''}`}
                                        </Typography>
                                    </>
                                }
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails onClick={e => e.stopPropagation()}>
                                <div>
                                    <div dangerouslySetInnerHTML={{__html: question.content}} className="question-container"/>
                                    <ul className="quiz-list-style-type">
                                        {question._cls === 'Question' ? (
                                            question.answers.map((answer, questionAnswerIndex) => (
                                                <li key={`quiz-question-${questionAnswerIndex}`}>
                                                    <div className="quiz-question-list-item-container">
                                                        <div className="quiz-question-list-item-indicator-admin">
                                                            {answer.correct && <Check className="quiz-check-green"/>}
                                                        </div>
                                                        <span dangerouslySetInnerHTML={{__html: answer.content}}/>
                                                    </div>
                                                </li>
                                            ))
                                        ) : (
                                            <>
                                                <p>Topic: {question.topic}</p>
                                                {question.subtopic != null && question.subtopic.trim() !== '' &&
                                                    <p>Subtopic: {question.subtopic}</p>
                                                }
                                                <p>Number of Questions: {question.numberOfQuestions}</p>
                                            </>
                                        )}
                                    </ul>
                                </div>
                            </ExpansionPanelDetails>
                            <Divider/>
                            <ExpansionPanelActions id="question-action-panel" onClick={e => e.stopPropagation()}>
                                <Button size="small" color="primary" id="move-up-arrow"
                                    onClick={(e) => this.handleUp(e, quizQuestionIndex)}
                                    disabled={quizQuestionIndex === 0}
                                >
                                    <UpArrow/> Move Up
                                </Button>
                                <Button size="small" color="primary" id="move-down-arrow"
                                    onClick={(e) => this.handleDown(e, quizQuestionIndex)}
                                    disabled={quizQuestionIndex === quizDataDict.questions.length - 1}
                                >
                                    <DownArrow/> Move Down
                                </Button>
                                {question._cls === 'Question' ? (
                                    <Button size="small" color="primary" href={`/questions/${question._id.$oid}`}>
                                        Edit
                                    </Button>
                                ) : (
                                    <Button size="small" color="primary" name="edit-quiz" onClick={() =>
                                        editRandomizedQuizQuestionAction(quizQuestionIndex)}>
                                        Edit
                                    </Button>
                                )}
                                <Button size="small" color="primary" name="delete-quiz" onClick={(e) =>
                                    removeQuestionFromQuizAction(e, quizQuestionIndex)}>
                                    Delete
                                </Button>
                            </ExpansionPanelActions>
                        </ExpansionPanel>
                    ))}
                </div>
                <SecondaryButton
                    size="small"
                    aria-label="Add randomized question set"
                    onClick={addRandomizedQuestion}
                >
                    <Shuffle/>&nbsp;Add randomized question set
                </SecondaryButton>

            </div>
        );
    }
}

export default withRouter(connect()(createForm()(QuizDetail)));
